import React, { Fragment } from 'react'

/** Component */
import { Cell } from 'components'

/** Images */
import {
	arduino,
	bootstrap,
	cpp,
	c4d,
	cc,
	csharp,
	figma,
	finalcutpro,
	gitkraken,
	html,
	js,
	json,
	qt,
	react,
	sass,
	sketch,
	unity,
	vscode,
	wordpress,
	xcode,
	treed,
	agile,
	concept,
	dev,
	graphic,
	iot,
	ux,
	video,
} from 'images'

/** STATIC DATA */
// import { staticdataskills, staticdataprogramming, staticdatasoftwares } from 'db'

const Skills = ({ title }) => {
	return (
		<Fragment>
			<div className="container my-6">
				{/* TITRE */}
				<h2 className="text-secondary text-center mb-4">{title}</h2>

				{/* SKILLS */}
				<div className="SectionCellGroup mx-auto">
					{/* {staticdataskills.cells.map(cell => (
						// Map creat an array - loop for all the cell in cells of cell.js
						<Cell
							title={cell.title}
							image={require('../../images/Skills/' + cell.image).default}
							key={cell.id}
						/>
					))} */}
					<Cell title="UX & UI Design" image={ux} />
					<Cell title="Méthode Agile" image={agile} />
					<Cell title="Développement front-end" image={dev} />
					<Cell title="Graphique Design" image={graphic} />
					<Cell title="Prototype IOT" image={iot} />
					<Cell title="Modélisation 3D" image={treed} />
					<Cell title="Montage vidéo" image={video} />
					<Cell title="Développement de concept" image={concept} />
				</div>
				{/* SOFTWARES */}
				<div className="SectionCellGroup mx-auto mt-5">
					<Cell title="Sketch" image={sketch} />
					<Cell title="Adobe Creative Suite" image={cc} />
					<Cell title="Figma" image={figma} />
					<Cell title="Cinema 4D" image={c4d} />
					<Cell title="Final Cut Pro" image={finalcutpro} />
					<Cell title="Wordpress" image={wordpress} />
					<Cell title="Visual Studio Code" image={vscode} />
					<Cell title="GitKraken" image={gitkraken} />
					<Cell title="QT Creator" image={qt} />
					<Cell title="Unity" image={unity} />
					<Cell title="Xcode" image={xcode} />
					<Cell title="Arduino" image={arduino} />
				</div>
				{/* PROGRAMING */}
				<div className="SectionCellGroup mx-auto mt-5">
					<Cell title="React / Gatsby / Vue JS" image={react} />
					<Cell title="SASS / CSS3" image={sass} />
					<Cell title="Bootstrap" image={bootstrap} />
					<Cell title="HTML5" image={html} />
					<Cell title="JS ES6" image={js} />
					<Cell title="Static Data JSON" image={json} />
					<Cell title="C++ (bases)" image={cpp} />
					<Cell title="C# (bases)" image={csharp} />
				</div>
			</div>
		</Fragment>
	)
}
export default Skills
